import styled, { css } from "styled-components";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
const { color, size, opacity } = ids || {};
const isDisabled = css `
  border: ${size.border_width.ids_size_border_small} dashed
    ${color.action.disabled.ids_color_action_disabled_variant};
  cursor: not-allowed;
`;
export const StyledArchiveContainer = styled.label `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border: ${size.border_width.ids_size_border_small} dashed
    ${color.action.secondary.ids_color_action_secondary_base};
  border-radius: ${size.general.ids_size_general_12x};
  padding: ${size.general.ids_size_general_24x};
  min-width: 312px;
  width: 100%;
  cursor: pointer;
  background: ${color.backgrounds.ids_color_bg_base};

  &:hover {
    background: ${({ disabled }) => disabled
    ? color.backgrounds.ids_color_bg_base
    : hexToRgba(color.action.secondary.ids_color_action_secondary_variant, opacity.ids_opacity_soft)};
  }

  ${({ disabled }) => disabled && isDisabled}
`;
//# sourceMappingURL=ArchiveButton.style.js.map